module.exports = __webpack_public_path__ + "img/28.e4ce21e2.png";